<!--
 * @Description: 征信查询授权协议书
 * @Author: 胡博君
 * @Date: 2019-07-19 17:23:27
 * @LastEditors: 庄佩芬
 * @LastEditTime: 2019-10-10 15:01:22
 -->

<template>
  <div class="protocol-search-protocol">
    <div class="content">
      <h3>代办服务告知书</h3>

      <p>
          鉴于客户需委托深圳市新千帆信息科技有限公司（以下简称“本公司”）代办抵押、解押登记等事宜，本公司同意接受客户委托。现就相关事项特告知如下：
          <br/>
          <span class="content__strong">一、委托事项：</span>
        <p>本公司负责完成客户委托的业务，包括代为办理车辆抵押、解押、备案、上配、过户、年审服务等。</p>
        <span class="content__strong">二、委托期限</span>
        <p>本协议有效期为本公司代为办理的业务办理完毕止。</p>
        <span class="content__strong">三、客户权利义务</span>
        <p>1、客户提供代办车辆解抵押登记所需的必备材料（如抵押人和抵押权人的身份证明、机动车登记证书、抵押人和抵押权人依法订立的主合同和抵押合同等，具体以车管所实际要求为准 ），以保证本公司顺利完成上述业务。</p>
        <p>2、客户应根据约定及时完整的支付本公司代办费用。</p>

        <span class="content__strong">四、本公司权利义务</span>
        <p>1、本公司应妥善保管车辆及客户或客户指定的第三方提供的相关证件、证明、抵押等资料，除本协议约定的用途外，不得挪作他用，更不得实施损害客户利益的行为。</p>
        <p>2、本公司应提前了解、并确认办理代办业务的当地法律法规政策及所需资料、流程，确保手续顺利完成。</p>
        <p>3、本公司应遵守国家地方法律法规及政策，遵照各行政部门的操作流程；做到服务业务规范合法，确保车辆解除手续的合法性、完整性及有效性，并独立承担代办业务中相应的义务和责任。</p>
        <p>4、未经客户书面同意，本公司不得将所有代办资料原件、复印件或以其他载体形式泄露或交予第三方。</p>
        <span class="content__strong">五、费用及支付</span>
        <p>1、本公司代办业务以件为单位收取：
            每台车辆办理抵押/注销抵押/备案/过户/年审等相关手续的服务费根据本公司公布的全国业务收费表收取。</p>
        <p>2、客户应于本协议签署生效当日向本公司支付代办服务费，<span style="">或者委托本公司合作的第三方机构代我司收取本协议项下代办服务费。</span></p>

        <span class="content__strong">六、 保密条款</span>
        <p>任何一方不得泄露、披露、擅自允许他人使用、许诺他人使用另一方的保密信息，并不得利用该保密信息进行违约、非法或牟利的行为。除了为履行本协议合理所需或经对方同意外，不得披露或使用任何保密信息，并应尽最大努力阻止他人披露或公布任何保密信息。</p>

        <span class="content__strong">七、违约责任</span>
        <p>如客户未按本协议约定及时向本公司支付费用，则每逾期一日，按应付未付费用的5‰/日向本公司支付逾期违约金。</p>

        <span class="content__strong">八、附则</span>
        <p> <span class="content__strong content__under-line">本告知书经客户勾选已阅读选项，即视为客户接受本告知书条款的约束，客户应按照告知书要求履行相应义务。</span></p>

    </div>
    <br/>
    <div class="footer" style="text-align: right">
      <div class="footer__item content__strong">
        <div class="footer__left">深圳市新千帆信息科技有限公司</div>
      </div>
      <div class="footer__item">
        <div class="footer__left content__strong">2021年6月7日</div>
      </div>

    </div>
  </div>
</template>
<script>
export default {
  mounted() {
    // 点击 查询授权书
    // this.$buryPoint.sendData('view_credit_authz_click');
  }
};

</script>
<style lang="scss">
.protocol-search-protocol {
  padding: 0 30px;
  line-height: 40px;
  .content{
    h3 {
      font-size: 34px;
      color: #30344d;
      padding: 50px 0 32px;
      text-align: center;
      font-weight: 700;
    }
    &__title {
      font-size: 26px;
      &--strong {
        font-weight: 700;
      }
      &--line {
        text-decoration: underline;
      }
    }
    &__strong {
      font-weight: 700;
    }
    &__under-line {
      text-decoration: underline;
    }
  }
}
</style>

